import React from 'react';

const Syringe = ({ percent }) => {
	const startX = 212;
	let endX = 1060;

	endX = startX + (endX - startX) * percent;

	const points = {
		start: {
			top: {
				x: startX,
				y: 120,
			},
			bottom: {
				x: startX,
				y: 275,
			},
		},
		end: {
			top: {
				x: endX,
				y: 120,
			},
			bottom: {
				x: endX,
				y: 275,
			},
		},
	};

	return (
		<div className="w-full relative">
			<div
				className="w-full h-full"
				style={{
					width: '75%',
				}}
			></div>
			{/* <img src={Overlay} className="absolute top-0 w-full" /> */}
			<svg
				id="Layer_1"
				data-name="Layer 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1257.81 394.95"
			>
				<defs></defs>
				<polyline
					class="cls-1"
					// points="1057.45 204.48 1058.45 125.48 212.45 122.48 212.45 273.48 1056.45 275.48"
					points={`${points.end.top.x} ${points.end.top.y} ${points.start.top.x} ${points.start.top.y} ${points.start.bottom.x} ${points.start.bottom.y} ${points.end.bottom.x} ${points.end.bottom.y}`}
				/>
				<g id="layer5">
					<g id="g3876">
						<path
							id="rect2995"
							class="cls-2"
							d="M197,280.23l7-164.65,853,2.67a5.28,5.28,0,0,1,5.26,5.36L1061,204l-1.11,74.57a4.43,4.43,0,0,1-4.43,4.36Z"
						/>
						<path
							id="rect3766"
							class="cls-3"
							d="M12.65,243.49V133h191.7V243.49Z"
						/>
						<path
							id="path3786"
							class="cls-4"
							d="M200.23,364.24v-352"
						/>
						<path
							id="path3786-1"
							class="cls-5"
							d="M11.07,333.11V43.36"
						/>
						<path
							id="path3818-4"
							class="cls-6"
							d="M775.5,273V211.71"
						/>
						<path
							id="path3818-4-4"
							class="cls-6"
							d="M918,273V211.71"
						/>
						<path
							id="path3872"
							d="M1062.5,212.84V191.67H1227l30.86,21.17Z"
						/>
					</g>
				</g>
				<path
					id="path3818-4-2"
					data-name="path3818-4"
					class="cls-6"
					d="M490.56,272.6V211.33"
				/>
				<path
					id="path3818-4-4-2"
					data-name="path3818-4-4"
					class="cls-6"
					d="M633,272.6V211.33"
				/>
				<path
					id="path3818-4-4-3"
					data-name="path3818-4-4"
					class="cls-6"
					d="M348.08,272.68V211.41"
				/>
				<path d="M317,336.17h10.09V314.51h-8.31v-5.4c5.06-.76,7.73-1.69,10.61-3.41h6.39v30.47h8.51v7H317Z" />
				<path d="M351,324.28c0-12.76,5.73-19.29,14.41-19.29s14.41,6.53,14.41,19.29-5.73,19.6-14.41,19.6S351,337,351,324.28Zm21.08,0c0-9.74-2.95-12.57-6.67-12.57s-6.67,2.83-6.67,12.57,2.95,12.88,6.67,12.88S372.09,334,372.09,324.28ZM361,324.16a4.43,4.43,0,1,1,4.42,4.51A4.28,4.28,0,0,1,361,324.16Z" />
				<path d="M458.83,337.61c10.74-9,18-15.37,18-20.77,0-3.63-2.25-5.61-6.18-5.61-3,0-5.42,1.83-7.54,3.8l-4.66-4.69c3.89-3.93,7.65-5.94,13.38-5.94,7.9,0,13.25,4.73,13.25,12,0,6.31-6.48,13-13.75,19.36,2.15-.22,4.86-.42,6.81-.42H487v7.3H458.83Z" />
				<path d="M494.11,323.69c0-12.75,5.73-19.29,14.41-19.29s14.4,6.54,14.4,19.29-5.73,19.61-14.4,19.61S494.11,336.41,494.11,323.69Zm21.08,0c0-9.73-3-12.56-6.67-12.56s-6.67,2.83-6.67,12.56,2.95,12.89,6.67,12.89S515.19,333.42,515.19,323.69Zm-11.1-.12a4.43,4.43,0,1,1,4.43,4.51A4.29,4.29,0,0,1,504.09,323.57Z" />
				<path d="M599.71,335.43l4-5.48a14.21,14.21,0,0,0,9.14,3.79c4.07,0,7-1.59,7-4.46,0-3.3-2.54-5.33-11.29-5.33v-6.14c7.34,0,10.08-2.05,10.08-5,0-2.62-2.15-4.11-5.55-4.11-2.94,0-5.38,1.21-7.94,3.26l-4.38-5.28a19.82,19.82,0,0,1,12.71-4.81c8.19,0,13.86,3.7,13.86,10.29,0,3.86-2.68,6.62-7.17,8.33v.23c4.71,1.23,8.38,4.28,8.38,9.14,0,7-6.94,10.9-14.86,10.9C607.3,340.74,602.61,338.59,599.71,335.43Z" />
				<path d="M635.94,321.14c0-12.76,5.73-19.29,14.4-19.29s14.41,6.53,14.41,19.29-5.73,19.6-14.41,19.6S635.94,333.86,635.94,321.14Zm21.07,0c0-9.74-3-12.57-6.67-12.57s-6.67,2.83-6.67,12.57,3,12.88,6.67,12.88S657,330.87,657,321.14ZM645.92,321a4.43,4.43,0,1,1,4.42,4.51A4.28,4.28,0,0,1,645.92,321Z" />
				<path d="M759.72,320.56c0-2.4.22-5.83.33-8.24h-.25c-1.24,2.13-2.76,4.25-4.09,6.38l-5.64,8.15h22.48v6.63H741.67v-6L757.32,305h10.49v37.47h-8.09Z" />
				<path d="M778.31,323.52c0-12.75,5.73-19.28,14.41-19.28s14.41,6.53,14.41,19.28-5.73,19.61-14.41,19.61S778.31,336.25,778.31,323.52Zm21.08,0c0-9.73-2.95-12.56-6.67-12.56s-6.67,2.83-6.67,12.56,3,12.89,6.67,12.89S799.39,333.26,799.39,323.52Zm-11.09-.11a4.43,4.43,0,1,1,4.42,4.51A4.28,4.28,0,0,1,788.3,323.41Z" />
				<path d="M885.69,336.41l3.91-5.5c2.46,2.07,5.31,3.75,8.84,3.75,4.27,0,7.24-2,7.24-5.87s-2.89-5.78-6.82-5.78c-2.49,0-3.78.47-6.31,1.9l-3.87-2.5,1-18.93h23v7.32H897.2l-.62,7a13.46,13.46,0,0,1,4.92-.86c6.9,0,12.88,3.66,12.88,11.63,0,8.32-7,13.09-14.69,13.09A19.46,19.46,0,0,1,885.69,336.41Z" />
				<path d="M921.68,322.06c0-12.75,5.73-19.28,14.41-19.28s14.4,6.53,14.4,19.28-5.73,19.61-14.4,19.61S921.68,334.78,921.68,322.06Zm21.08,0c0-9.73-3-12.56-6.67-12.56s-6.67,2.83-6.67,12.56,3,12.89,6.67,12.89S942.76,331.8,942.76,322.06Zm-11.1-.11a4.43,4.43,0,1,1,4.43,4.5A4.28,4.28,0,0,1,931.66,322Z" />
				<rect x="19.45" y="137.48" width="178" height="106" />
				<path d="M579.35,379.51h2l.22,2h.06c.78-1.4,1.71-2.36,3.45-2.36,1.48,0,2.41.87,2.85,2.61.87-1.62,1.8-2.61,3.53-2.61,2.11,0,3.35,1.64,3.35,4.65v10.79h-2.54V384c0-1.74-.5-2.64-1.61-2.64s-1.62.78-2.42,2.33v10.91h-2.36V384c0-1.74-.43-2.64-1.55-2.64s-1.74.78-2.48,2.33v10.91h-2.54Z" />
				<path d="M605.92,381.59h-7v-2.08h9.55v15.07h-2.57Zm-1-7.22a2.05,2.05,0,1,1,2.05,2A1.94,1.94,0,0,1,604.89,374.37Z" />
				<path d="M622.38,389.53V374.58H617v-2.07H625v17.2c0,2.17,1.18,3.1,3,3.1a6.74,6.74,0,0,0,2.82-.68l.65,1.92a9.16,9.16,0,0,1-4,.9C624.14,395,622.38,393.09,622.38,389.53Z" />
				<path d="M641,389.53V374.58h-5.34v-2.07h7.91v17.2c0,2.17,1.18,3.1,3,3.1a6.74,6.74,0,0,0,2.82-.68l.65,1.92a9.16,9.16,0,0,1-4,.9C642.74,395,641,393.09,641,389.53Z" />
				<path d="M653.81,387.08c0-5.06,3.47-7.94,7.44-7.94s7.44,2.88,7.44,7.94-3.47,7.87-7.44,7.87S653.81,392.07,653.81,387.08Zm12.25,0c0-3.47-1.93-5.8-4.81-5.8s-4.81,2.33-4.81,5.8,1.93,5.73,4.81,5.73S666.06,390.52,666.06,387.08Z" />
				<path d="M673.43,379.51h2.11l.22,2.55h.12c1.58-1.65,3.32-2.92,5.68-2.92,3.56,0,5.2,2.11,5.2,6.08v9.36h-2.57v-9c0-2.85-1-4.19-3.44-4.19-1.8,0-3,.9-4.74,2.7v10.51h-2.58Z" />
				<path
					id="path3818-4-4-4"
					data-name="path3818-4-4"
					class="cls-6"
					d="M205.61,271.46V210.19"
				/>
				<path
					id="path3818-4-4-5"
					data-name="path3818-4-4"
					class="cls-6"
					d="M1060.45,270.67V209.4"
				/>
			</svg>
		</div>
	);
};

export default Syringe;
